import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { PartnerProduct } from '../../interfaces/partner-product.interface';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-partner-product',
  standalone: false,
  templateUrl: './partner-product.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./partner-product.component.scss']
})
export class PartnerProductComponent {
  @Input() product!: PartnerProduct;
  imagesUrl = environment.ImagesUrl;
}
